import BaseTable from 'components/base-table';
import MainCard from 'components/MainCard';
import ScrollX from 'components/ScrollX';
import { PlayerDto } from 'inside-fifa/api/players/dto';
import { Alert, Button, Dialog } from '@mui/material';
import { Stack, Box } from '@mui/system';
import { PopupTransition } from 'components/@extended/Transitions';
import PlayerFormDialog from './partials/player-form-dialog';
import { usePlayersListColumnsConfig, usePlayersManagement } from './hooks';
import { isUserInAllowedGroup } from 'utils/route-guard/roles-check';
import useAuth from 'hooks/useAuth';
import { INSIDE_FIFA_TEAM_ADMIN } from 'inside-fifa/setup/auth';

const PlayersListPage = () => {
    const {
        fetchPlayers,
        players,
        pageCount,
        editMode,
        isDialogOpen,
        selectedPlayer,
        onAddPlayerClick,
        onCloseDialogClick,
        onSelectPlayer,
        onSubmit,
        onDeletePlayer,
    } = usePlayersManagement();
    const { columns, defaultVisibleColumns } = usePlayersListColumnsConfig({
        onEditPlayer: onSelectPlayer,
        onDeletePlayer,
    });
    const { user } = useAuth();
    const isEditAvailable = isUserInAllowedGroup(user?.groups ?? [], [INSIDE_FIFA_TEAM_ADMIN]);

    return (
        <>
            <Box sx={{ mb: 4 }}>
                <Alert severity="info">
                    This is Inside FIFA BackOffice DEMO. Please do not use this functionality, as it will be removed
                    soon.
                </Alert>
            </Box>
            <MainCard content={false}>
                <Stack direction="column">
                    {isEditAvailable && (
                        <Box sx={{ p: 2 }}>
                            <Button variant="contained" color="primary" onClick={onAddPlayerClick}>
                                Add Player
                            </Button>
                        </Box>
                    )}
                    <ScrollX>
                        <BaseTable<PlayerDto>
                            data={players}
                            fetchData={fetchPlayers}
                            pageCount={pageCount}
                            defaultColumnConfig={columns}
                            defaultVisibleColumnConfig={defaultVisibleColumns}
                        />
                    </ScrollX>
                </Stack>
            </MainCard>
            <Dialog
                maxWidth="sm"
                TransitionComponent={PopupTransition}
                fullWidth
                open={isDialogOpen}
                sx={{ '& .MuiDialog-paper': { p: 0 } }}
            >
                <PlayerFormDialog
                    onCancel={onCloseDialogClick}
                    initialValues={selectedPlayer}
                    editMode={editMode}
                    onSubmit={onSubmit}
                />
            </Dialog>
        </>
    );
};

export default PlayersListPage;
